import { EnvironmentProviders, inject, makeEnvironmentProviders } from '@angular/core';
import { APP_CONFIG } from './app.tokens';
import { BrowserCacheLocation, IPublicClientApplication, PublicClientApplication } from '@azure/msal-browser';
import { InteractionType } from '@azure/msal-browser';
import { MSAL_GUARD_CONFIG, MSAL_INSTANCE, MSAL_INTERCEPTOR_CONFIG, MsalBroadcastService, MsalGuard, MsalGuardConfiguration, MsalInterceptor, MsalInterceptorConfiguration, MsalService } from '@azure/msal-angular';
import { HTTP_INTERCEPTORS } from '@angular/common/http';

export function MSALInstanceFactory(): IPublicClientApplication {
  const config = inject(APP_CONFIG);
  
  return new PublicClientApplication({
    auth: {
      clientId: config.mslConfig.clientId,
      authority: `${config.mslConfig.authority}/common/`,
      redirectUri: config.mslConfig.redirectUri,
    },
    cache: {
      cacheLocation: BrowserCacheLocation.LocalStorage,
      storeAuthStateInCookie: true,
    },
  });
}

export function MSALGuardConfigFactory(): MsalGuardConfiguration {
  return {
    interactionType: InteractionType.Redirect,
  };
}

export function MSALInterceptorConfigFactory(): MsalInterceptorConfiguration {
  const config = inject(APP_CONFIG);
  
  return {
    interactionType: InteractionType.Redirect,
    protectedResourceMap: new Map<string, string[]>([
      [
        `${config.apiUrl}/*`,
        [
          config.mslConfig.apiScopes
        ],
      ],
    ]),
  };
}

export function provideAuth(): EnvironmentProviders {
    return makeEnvironmentProviders([
        {
            provide: MSAL_INSTANCE,
            useFactory: MSALInstanceFactory
        },
        {
            provide: MSAL_GUARD_CONFIG,
            useFactory: MSALGuardConfigFactory
        },
        {
            provide: MSAL_INTERCEPTOR_CONFIG,
            useFactory: MSALInterceptorConfigFactory
        },
        {
              provide: HTTP_INTERCEPTORS,
              useClass: MsalInterceptor,
              multi: true,
            },
            MsalService,
            MsalGuard,
            MsalBroadcastService,
    ])
}